<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="customerName">
        <el-input v-model="queryParams.customerName" filterable placeholder="客户名称" @keyup.enter.native="search" clearable> </el-input>
      </el-form-item>
      <el-form-item  prop="number">
        <el-input v-model="queryParams.number" placeholder="出货单号" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="shipmentNo">
        <el-input v-model="queryParams.shipmentNo" placeholder="申请单编码" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="createUsername">
        <el-input v-model="queryParams.createUsername" placeholder="创建人" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="status">
        <el-select v-model="queryParams.status" filterable placeholder="审核状态" @change="search" clearable>
          <el-option label="待提交" value="0"></el-option>
          <el-option label="审核中" value="1"></el-option>
          <el-option label="审核通过" value="2"></el-option>
          <el-option label="审核驳回" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="logisticsInfo">
        <el-input v-model="queryParams.logisticsInfo" placeholder="物流信息" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="receiverInfo">
        <el-input v-model="queryParams.receiverInfo" placeholder="收货信息" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="remark">
        <el-input v-model="queryParams.remark" placeholder="备注" @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="dateRange">
        <el-date-picker
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="dateRange"
          @change="search"
          type="daterange"
          range-separator="-"
          start-placeholder="出货开始日期"
          end-placeholder="出货结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="adds" v-hasPermi="['shipment:outEntrepot:update']">新增</el-button>
        <el-button type="primary" icon="el-icon-download" @click="outEntrepotExport" v-hasPermi="['shipment:outEntrepot:export']">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" ref="tableData" border v-loading="loading" @sort-change="tableSortChange">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="table-expand">
            <el-row>
              <el-col :span="6">
                <el-form-item label="申请单编码：" >
                  <span>{{ props.row.shipmentNo }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="创建人：" >
                  <span>{{ props.row.createUsername }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="备注：" >
                  <span>{{ props.row.remark }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="ids" label="序号" align="center" width="60"></el-table-column>
      <el-table-column prop="createTime" label="出货日期" align="center" min-width="140" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime,'{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="number" label="出货单号" align="center" min-width="130" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="customerName" label="客户名称" align="center" width="260" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="status" label="审核状态" align="center" min-width="100">
          <template slot="header">
              <el-tooltip content="审核中表示提交成功" placement="top">
                  <i class="el-icon-question"></i>
              </el-tooltip>
              审核状态
          </template>
        <template slot-scope="{ row }">
          <el-tag v-if="row.status == 0">待提交</el-tag>
          <el-tag v-else-if="row.status == 1">审核中</el-tag>
          <el-tag v-else-if="row.status == 10">审核中</el-tag>
          <el-tag v-else-if="row.status == 2" type="success">审核通过</el-tag>
          <el-tag v-else-if="row.status == 3" type="danger">审核驳回</el-tag>
        </template>
      </el-table-column>
        <el-table-column prop="cancelFlag" label="是否作废" align="center">
            <template slot-scope="{row}">
                <el-tag v-if="row.cancelFlag == '0'" type="success">否</el-tag>
                <el-tag v-else type="danger">是</el-tag>
            </template>
        </el-table-column>
      <el-table-column prop="logisticsStatus" label="物流状态" align="center">
            <template slot-scope="{row}">
                <el-tag type="danger" v-if="row.logisticsStatus == '0'">未发货</el-tag>
                <el-tag type="success" v-if="row.logisticsStatus == '1'">已发货</el-tag>
            </template>
      </el-table-column>
        <el-table-column label="物流信息" align="center" min-width="120" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span v-if="row.logisticsCompany">{{row.logisticsCompany}},</span>
                <span v-if="row.logisticsNo">{{row.logisticsNo}}</span>
            </template>
        </el-table-column>
        <el-table-column label="收货信息" align="center" min-width="120" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
                <span v-if="row.receiverMan">{{row.receiverMan}},</span>
                <span v-if="row.receiverPhone">{{row.receiverPhone}},</span>
                <span v-if="row.receiverAddr">{{row.receiverAddr}}</span>
            </template>
        </el-table-column>
      <el-table-column prop="paymentRemark" label="付款备注" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作" min-width="140" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-view" @click="detailInfo(scope.row)">详情</el-button>
            <el-dropdown @command="(command) => handleCommand(command, scope.row)" v-if="hasDropdownItems(scope.row)">
              <span class="el-dropdown-link">
                <i class="el-icon-d-arrow-right el-icon--right"></i>更多
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-hasPermi="['shipment:outEntrepot:flowView']" command="viewProcess" v-if="scope.row.status != 0" icon='el-icon-view'>查看流程</el-dropdown-item>
                <el-dropdown-item v-hasPermi="['shipment:outEntrepot:update']"   command="toEdit" v-if="(scope.row.status ==0 || scope.row.status ==3) && scope.row.cancelFlag == 0" icon="el-icon-edit">编辑</el-dropdown-item>
                <el-dropdown-item v-hasPermi="['shipment:outEntrepot:cwVerify']" command="financialVerify" v-if="scope.row.status ==1 && scope.row.cancelFlag == 0" icon="el-icon-s-check">财务审核</el-dropdown-item>
                <el-dropdown-item v-hasPermi="['shipment:outEntrepot:ckVerify']" command="outBoundVerify" v-if="scope.row.status ==10 && scope.row.cancelFlag == 0"  icon="el-icon-s-check">出库审核</el-dropdown-item>
                <el-dropdown-item v-hasPermi="['shipment:outEntrepot:logistics']" command="openFeedback" v-if="scope.row.cancelFlag == 0" icon="el-icon-truck">反馈物流</el-dropdown-item>
                <el-dropdown-item v-hasPermi="['shipment:outEntrepot:paymentRmk']" command="openPaymentRmk" v-if="scope.row.cancelFlag == 0" icon="el-icon-edit">付款备注</el-dropdown-item>
                <el-dropdown-item v-hasPermi="['shipment:outEntrepot:invalid']"    v-if="scope.row.cancelFlag == 0" command="cancelBill" icon="el-icon-s-release">作废</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <!-- 物流备注 -->
    <el-dialog title="物流信息" :visible.sync="dialogFormVisible" width="30%">
      <el-form :model="logisticsForm">
        <el-form-item label="物流公司" :label-width="formLabelWidth">
          <el-input v-model="logisticsForm.logisticsCompany" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" :label-width="formLabelWidth">
          <el-input v-model="logisticsForm.logisticsNo" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="收货人" :label-width="formLabelWidth">
          <el-input v-model="logisticsForm.receiverMan" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="收货电话" :label-width="formLabelWidth">
          <el-input v-model="logisticsForm.receiverPhone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="收货地址" :label-width="formLabelWidth">
          <el-input v-model="logisticsForm.receiverAddr" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="feedbackLogistic()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 付款备注 -->
    <el-dialog title="付款备注" :visible.sync="payRmkFormVisible" width="30%">
      <el-form :model="payRmkForm">
        <el-form-item label="备注信息">
          <el-input v-model="payRmkForm.paymentRemark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="payRmkFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="paymentRmk()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { outEntrepotList, submitOutEntrepotLogistic, invalidOutEntrepot, submitPaymentRmk } from "@/api/api.js";
import { mapGetters } from 'vuex';
export default {
  name: 'outEntrepot',
  data () {
    return {
      loading: false,
      logisticsForm: {
        id: null,
        logisticsCompany: null,
        logisticsNo: null,
        receiverMan: null,
        receiverPhone: null,
        receiverAddr: null,
      },
      dialogFormVisible: false,
      formLabelWidth: '120px',
      payRmkFormVisible: false,
      payRmkForm: {id: null, paymentRemark: null},
      queryParams: {
        customerName:undefined,
        number:undefined,
        shipmentNo:undefined,
        status:undefined,
        createUsername:undefined,
        remark:undefined,
        logisticsInfo:undefined,
        receiverInfo:undefined,
        startTime:undefined,
        endTime:undefined,
      },
      tableData: [{
        id: null,
        customerName: null,
        billingDate: null,
        remark: null,
        documenter: null,
        financial: null,
        entrepot: null,
        number: null,
        tailNo: null,
        customerSignature: null,
        total: null,
        status: null,
        shipmentId: null,
        flowId: null
      }],
      dateRange: [],
      page: 1,
      pageSize: 20,
      total: 0,
      rules: {
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
      },
      agentOptions: [],
      // 排序方式
      sortOrder: "",
      // 排序名称
      sortName: "",
    }
  },
  computed: {
    ...mapGetters(['entrepotLastUpdated']),
    adminShow () {
      return this.$store.getters.user.userType == '1';
    }
  },
  methods: {
    hasDropdownItems(row) {
      return (
        (this.checkPermi(['shipment:outEntrepot:flowView']) && row.status != 0) ||
        (row.cancelFlag == 0 && this.checkPermi(['shipment:outEntrepot:update']) && (row.status == 0 || row.status == 3)) ||
        (row.cancelFlag == 0 && this.checkPermi(['shipment:outEntrepot:cwVerify']) && row.status == 1) ||
        (row.cancelFlag == 0 && this.checkPermi(['shipment:outEntrepot:ckVerify']) && row.status == 10) ||
        (row.cancelFlag == 0 && this.checkPermi(['shipment:outEntrepot:logistics'])) ||
        (row.cancelFlag == 0 && this.checkPermi(['shipment:outEntrepot:paymentRmk'])) ||
        (row.cancelFlag == 0 && this.checkPermi(['shipment:outEntrepot:invalid']))
      );
    },
    // 搜索
    search () {
      this.tableData = [];
      this.page = 1;
      this.initData();
    },
    // 重置
    resetQuery () {
      this.dateRange = [];
      this.resetForm("queryForm");
      this.search();
    },
    // 排序
    tableSortChange (val) {
      this.sortOrder = val.order == "descending" ? "desc" : "asc";
      this.sortName = val.prop == "createTime" ? "createTime" : "updateTime";
      this.initData();
    },
    // 获取列表的数据
    initData () {
      let params = {
        model: {
          ... this.addDateRange(this.queryParams, this.dateRange),
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.tableData = [];
      outEntrepotList(params).then(res => {
        this.loading = false;
        this.tableData = res.data.data.records;
        this.tableData.map((item, index) => {
              item.ids = index + 1
        })
        this.total = res.data.data.total;
      })
    },
    handleCommand(command, row) {
      switch (command) {
        case "viewProcess":
          this.flowDetail(row);
          break;
        case "toEdit":
          this.edit(row);
          break;
        case "financialVerify":
          this.financialVerify(row);
          break;
        case "outBoundVerify":
          this.outBoundVerify(row);
          break;
        case "openFeedback":
          this.openFeedback(row);
          break;
        case "openPaymentRmk":
          this.openPaymentRmk(row);
          break;
        case "cancelBill":
          this.openCancel(row);
          break;
        default:
          break;
      }
    },

      openCancel(row) {
          this.$confirm('此操作将作废单据?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true,
          }).then(() => {
              invalidOutEntrepot({id: row.id}).then((res) => {
                  if (res.data.code == 200) {
                      this.$message({
                          title: "成功",
                          message: "操作成功",
                          type: "success",
                          duration: 1500,
                      });
                      this.initData();
                  } else {
                      this.$message.error(res.data.message);
                  }
              });
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消'
              });
          });
      },

    // 新增
    adds () {
      this.$router.push({ path: '/shipmentRequest/outEntrepotUpdate', query: {}})
    },
    //修改
    edit (row) {
      this.$router.push({ path: '/shipmentRequest/outEntrepotUpdate', query: {id: row.id, shipmentId: row.shipmentId}})
    },
    detailInfo(row) {
      this.$router.push({
        path: "/outEntrepot/outEntrepotDetail",
        query: {id: row.id, processId: row.flowId, shipmentId: row.shipmentId}
      });
    },
    financialVerify(row) {
      this.$router.push({
        path: "/outEntrepot/flowOutEntrepotAct",
        query: {id: row.id, processId: row.flowId}
      });
    },
    outBoundVerify(row) {
      this.$router.push({
        path: "/outEntrepot/flowOutEntrepotAct",
        query: {id: row.id, processId: row.flowId}
      });
    },
    flowDetail (row) {
      this.$router.push({
        path: "/outEntrepot/outEntrepotFlowView",
        query: {id: row.id, processId: row.flowId}
      });
    },
    openFeedback(row) {
      this.dialogFormVisible = true;
      this.logisticsForm.id = row.id;
    },
    feedbackLogistic() {
      if (!this.logisticsForm.logisticsCompany) {
        this.$message.error("物流公司不能为空，自提或送货请填写办理人");
        return
      }
      submitOutEntrepotLogistic(this.logisticsForm).then((res) => {
        if (res.data.code == 200) {
          this.$notify({
            title: "成功",
            message: "反馈物流成功",
            type: "success",
            duration: 1500,
          });
          this.dialogFormVisible = false;
          this.logisticsForm = {};
          this.initData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    openPaymentRmk(row) {
      this.payRmkFormVisible = true;
      this.payRmkForm.id = row.id;
    },
    paymentRmk() {
      if (!this.payRmkForm.paymentRemark) {
        this.$message.error("备注信息不能为空");
        return
      }
      submitPaymentRmk(this.payRmkForm).then((res) => {
        if (res.data.code == 200) {
          this.$notify({
            title: "成功",
            message: "付款备注成功",
            type: "success",
            duration: 1500,
          });
          this.payRmkFormVisible = false;
          this.payRmkForm = {id: null, paymentRemark: null};
          this.initData();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 弹窗的取消
    cancelDialog () {
      this.dialog = false;
    },
    outEntrepotExport(){
      let params = {
        ... this.addDateRange(this.queryParams, this.dateRange)
      }
      this.download('/outEntrepot/exportList', params, `出库单导出_${new Date().getTime()}.xlsx`)
    }
  },
  mounted () {
    this.initData();
  },
  created () {},
    watch: {
        '$route': {
            handler: function (to, from) {
                if (to.name == "outEntrepot") {
                    this.initData();
                }
            },
            // 深度观察监听
            deep: true,
        },
        entrepotLastUpdated(newVal, oldVal) {
          this.initData();
        }
    },
    
};
</script>
<style scoped lang="less">
.table-expand{
  margin-left: 20px;
  label{
    width: 90px;
    color: #99a9bf; 
  }
  .el-form-item{
    margin-bottom: 0;
  }
}
</style>


